import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import StoreWebservice from '../../../webservices/StoreWebservice';
import Loading from '../../../components/Loading';
import ChangeOrganization from './ChangeOrganization';
import Installation from './Installation';
import './Form.scss'

const storeWebservice = new StoreWebservice();
const { Button, CardSection, Input, Label, MessageBox } = require('@paymongo/seeds');

interface isForm {
  id: string;
  isAssociated: boolean;
  getStore: Function;
  sessionToken: string;
  setShowForm: Function;
  tradeName: string;
}

const Form = ({ id, isAssociated, getStore, sessionToken, setShowForm, tradeName }: isForm) => {
  const [associationError, setAssociationError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState: { isSubmitted, isSubmitSuccessful, isValid } } = useForm();
  const onSubmit = async (data: object) => {
    setLoading(true);

    if(!isValid) setAssociationError(false);

    try {
      await storeWebservice.associateOrganization(id, data, sessionToken);
      getStore();
      setAssociationError(false);
      setLoading(false);
    } catch(error) {
      setAssociationError(true);
      setShowForm(true);
      setLoading(false);
    }
  };

  const validateInput: Function = () => {
    if(!isValid) setAssociationError(false)
  }


  const renderFormMessage: Function = (): JSX.Element => {
    if(isAssociated) return <ChangeOrganization tradeName={tradeName} setShowForm={() => setShowForm(false)} />;

    return <Installation />;
  }

  const invalidValues: boolean = isSubmitted && !isSubmitSuccessful && !isValid;

  return (
    <Loading loading={loading}>
      <CardSection className="form">
        { invalidValues &&
          <div className="--pb-lg form__error">
            <MessageBox type="error">
              The public and secret keys can not be empty. Please try again.
            </MessageBox>
          </div>
        }
        { associationError &&
          <div className="--pb-lg form__error">
            <MessageBox type="error">
              We could not find your PayMongo account, please check <br />
              both your public and secret keys and try again.
            </MessageBox>
          </div>
        }
        { renderFormMessage() }

        <Label className="text --bold" htmlFor="pk">
          Public Key
        </Label>
        <Input id="pk" { ...register('public_key', { required: true }) } onChange={validateInput} />

        <Label className="text --bold" htmlFor="sk">
          Secret Key
        </Label>
        <Input id="sk" { ...register('secret_key', { required: true }) } onChange={validateInput} />
        <br /><br />

        <div>
          <Button type="brand" className="text --bold --mr-md" onClick={ handleSubmit(onSubmit) }>
            Connect my PayMongo Account
          </Button>

        </div>
      </CardSection>
    </Loading>
  );
}

export default Form;
